// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "follow-the-money-3271b.firebaseapp.com",
  "projectId": "follow-the-money-3271b",
  "storageBucket": "follow-the-money-3271b.appspot.com",
  "messagingSenderId": "739632826498",
  "appId": "1:739632826498:web:79a3b561fed20aeb0ecc9b",
  "measurementId": "G-DCCH4VZ11S",
  "apiKey": "AIzaSyBiRoHkOPSkPR3XBMjyEuU53tqZnzeo_RM"
};
